import { render } from "./TheBBCUpper.vue?vue&type=template&id=47664106"
import script from "./TheBBCUpper.vue?vue&type=script&lang=js"
export * from "./TheBBCUpper.vue?vue&type=script&lang=js"
script.render = render

export default script